<template>
	<nav class="order-nav margin-b-100" v-if="showStepper">

		<ul v-if="productType === 'App\\Product'">
			<li>
                <router-link active-class="active" :to="{name:'order.summary'}" v-if="!isStepperLocked">Ordre</router-link>
                <a class="disabled" href="#" @click.prevent="" v-else>Ordre</a>
            </li>
			<li>
				<router-link active-class="active" :to="{name:'order.information'}" v-if="completedSummary && !isStepperLocked">Oplysninger</router-link>
				<a class="disabled" href="#" @click.prevent="" v-else>Oplysninger</a>
			</li>
			<li>
				<router-link active-class="active" :to="{name:'order.delivery'}" v-if="completedInformation && !isStepperLocked">Levering</router-link>
				<a class="disabled" href="#" @click.prevent="" v-else>Levering</a>
			</li>
			<li>
				<router-link active-class="active" :to="{name:'order.approve'}" v-if="completedDelivery">Bekræftelse</router-link>
				<a class="active" href="#" @click.prevent="" v-else-if="completedDelivery && isStepperLocked">Bekræftelse</a>
				<a class="disabled" href="#" @click.prevent="" v-else>Bekræftelse</a>
			</li>
		</ul>

        <ul v-if="productType === 'App\\CustomProduct'">
            <li>
                <router-link active-class="active" :to="{name:'custom.order.summary'}" v-if="!isStepperLocked">Ordre</router-link>
                <a class="disabled" href="#" @click.prevent="" v-else>Ordre</a>
            </li>
            <li>
                <router-link active-class="active" :to="{name:'custom.order.information'}" v-if="completedSummary && !isStepperLocked">Oplysninger</router-link>
                <a class="disabled" href="#" @click.prevent="" v-else>Oplysninger</a>
            </li>
            <li>
                <router-link active-class="active" :to="{name:'custom.order.delivery'}" v-if="completedInformation && !isStepperLocked">Levering</router-link>
                <a class="disabled" href="#" @click.prevent="" v-else>Levering</a>
            </li>
            <li>
                <router-link active-class="active" :to="{name:'custom.order.approve'}" v-if="completedDelivery">Bekræftelse</router-link>
                <a class="active" href="#" @click.prevent="" v-else-if="completedDelivery && isStepperLocked">Bekræftelse</a>
                <a class="disabled" href="#" @click.prevent="" v-else>Bekræftelse</a>
            </li>
        </ul>

	</nav>
</template>

<script>
	import {mapGetters} from 'vuex';
    export default {
        name: "stepper",
		computed:{
            ...mapGetters({
                completedProduct: 'completedProduct',
                completedSummary:'completedSummary',
                completedInformation:'completedInformation',
                completedDelivery:'completedDelivery',
                isStepperLocked:'isStepperLocked',
                productType:'productType',
		    }),
            showStepper(){
                return this.$route.name !== 'order.complete' &&
                    this.$route.name !== 'order.failed' &&
                    this.$route.name !== 'order.card.failed' &&
                    this.$route.name !== 'custom.order.complete' &&
                    this.$route.name !== 'custom.order.failed' &&
                    this.$route.name !== 'custom.order.card.failed' &&
                    this.$route.name !== 'custom.order.payment';
            }
        }
    }
</script>

<style scoped>

</style>
